import { createReducer, on } from '@ngrx/store';

import {
	fetchAvailableMarketplaceMembersSuccess,
	fetchKnownPermissionsPerElementSuccess,
	resetAvailableMarketplaceMembers,
	setUser,
} from './app.actions';
import { CoreOriginalSliceState } from './app.state';

export const coreReducer = createReducer<CoreOriginalSliceState>(
	new CoreOriginalSliceState(),
	on(setUser, (state, action) => state.setCurrentUser(action.user)),
	on(fetchKnownPermissionsPerElementSuccess, (state, action) =>
		state.setAvailablePermissions(action.permissions)
	),
	on(fetchAvailableMarketplaceMembersSuccess, (state, action) =>
		state.setAvailableMarketplaceMembers(action.members, action.total)
	),
	on(resetAvailableMarketplaceMembers, (state) =>
		state.resetAvailableMarketplaceMembers()
	)
);
